import type { ReactNode } from 'react';

interface Props {
  normal?: boolean;
  className?: string;
  children: ReactNode;
}

const PrimaryLabel = ({ children, normal, className = '' }: Props) => {
  return <p className={`m-0 ${normal ? 'normal-text' : 'primary-text'} ${className}`}>{children}</p>;
};

export default PrimaryLabel;
